import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TemplateService } from '../../../../services/template.service';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgForOf } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { TrimValueAccessorDirective } from '../../../../utils/trim-value-accessor.directive';
import { ToastBarService } from '../../../../services/toast-bar.service';

@Component({
    selector: 'app-import-legacy-template',
    imports: [
        ReactiveFormsModule,
        NgForOf,
        ButtonDirective,
        TrimValueAccessorDirective // <-- dodaj direktivu u imports
    ],
    templateUrl: './import-legacy-template.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './import-legacy-template.component.scss'
})
export class ImportLegacyTemplateComponent implements OnInit {
  @Input() onClose!: () => void;

  form!: FormGroup;
  languageOptions: { label: string; value: string }[] = [];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    protected templateService: TemplateService,
    private toastBarService: ToastBarService) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      templateFolder: ['', []],
      templateName: ['', []],
      language: ['E', []],
    })

    this.languageOptions = [
      {label: 'en', value: 'E'},
      {label: 'de', value: 'DE'},
      {label: 'hr', value: 'HR'},
    ];
  }

  protected onSubmit() {
    const payload = {...this.form.value};
    console.log("this prop form:", this.form.value);

    this.templateService.getLegacyTemplate(payload)
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: async (response: any) => {
          if (response?.fieldNames?.length > 0) {
            console.log("got response:", response);
            this.closeFromChild()
            await this.router.navigateByUrl('/', {skipLocationChange: true});

            await this.router.navigate(['/convert-template'], {
              state: {
                template: response,
                templateName: this.form.get('templateName')?.value,
                language: this.form.get('language')?.value
              },
              replaceUrl: true
            });
          } else {
            this.toastBarService.showToast({
              severity: 'warn',
              summary: 'Warn',
              detail: `Template "${this.form.get('templateFolder')?.value}/${this.form.get('templateName')?.value}" not found`,
            });
          }
        },

        error: (error: any) => {
          console.error("Error get legacy template" + error.message);
          this.toastBarService.showToast({
            severity: 'error',
            summary: 'Error',
            detail: `${error.message}`,
          });
          this.closeFromChild()
        }
      })
  }

  closeFromChild() {
    this.onClose()
  }

  private _destroy$ = new Subject<void>();

}
